// ABOUTME: no_enter_gate (dev): the collection rail's labels come from the agent's `reel_product`, which only arrives after the entry
// ABOUTME: tap — so a returning guest's carousel landed label-less. Remember the last envelope and show it until the live one lands.

import { useEffect, useMemo, useState } from 'react';

export const REMEMBERED_REEL_KEY = 'versai_reel_product_v1';

function read() {
  try {
    const raw = window.localStorage.getItem(REMEMBERED_REEL_KEY);
    const v = raw ? JSON.parse(raw) : null;
    return v && v.product && v.rail && Array.isArray(v.rail.items) ? v : null;
  } catch {
    return null;
  }
}

/**
 * @param {object} p
 * @param {boolean} p.enabled the landing is engaged (flag-off: nothing is read or written, the live value passes straight through)
 * @param {{product: object, rail: object}|null} p.live App's reelProduct (the agent's envelope, null until it arrives)
 * @returns {{product: (object|undefined), rail: (object|undefined)}} what the reel shows: live when there is one, else the
 *   remembered one. Only the product and the rail are remembered — tag eligibility/regions stay live-only.
 */
export default function useRememberedReel({ enabled, live }) {
  // Read when the landing engages (that waits on /api/config), not at mount, and once: a later write must not swap it mid-visit.
  const [remembered, setRemembered] = useState(null);
  useEffect(() => { if (enabled) setRemembered((prev) => prev || read()); }, [enabled]);

  useEffect(() => {
    if (!enabled || !live?.product || !live?.rail) return;
    try {
      window.localStorage.setItem(REMEMBERED_REEL_KEY, JSON.stringify({ product: live.product, rail: live.rail }));
    } catch { /* storage full or blocked: the next visit simply lands label-less, as before */ }
  }, [enabled, live]);

  return useMemo(() => {
    const source = live || (enabled ? remembered : null);
    return { product: source?.product, rail: source?.rail };
  }, [live, enabled, remembered]);
}
